<template>
<div>
  <vue-tabs @tab-change="handleTabChange">
    <v-tab v-for="(item, key) in typeAgencies" :key="key" :title="item.name" :id="item.slug">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/3">
          <vs-card>
            <div slot="header">
              <span v-if="status">Ajouter une clé</span>
              <span v-else>Modifier une clé</span>
            </div>
            <vs-row style="margin-bottom:10px">
              <vs-col>
                <vs-input :disabled="item.form.key == 'Evaluation' && status === false ? true : false" class="w-full" label="Clé"
                          :danger="error.key ? true : false"
                          :danger-text="error.key ? error.key[0] : ''"
                          v-model="item.form.key"
                />
              </vs-col>
            </vs-row>
            <vs-row style="margin-bottom:10px">
              <vs-col>
                <vs-input class="w-full" label="Pondération"
                          type="number"
                          min="1"
                          :danger="error.ponderation ? true : false"
                          :danger-text="error.ponderation ? error.ponderation[0] : ''"
                          v-model="item.form.ponderation"
                />
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <vs-textarea maxlength="170" class="w-full" label="Objectif"
                            :danger="error.objectif ? true : false"
                            :danger-text="error.objectif ? error.objectif[0] : ''"
                            v-model="item.form.objectif"
                ></vs-textarea>
              </vs-col>
            </vs-row>
            <vs-row style="margin-top:5px">
              <div class="flex flex-wrap-reverse items-center flex-grow justify-between mb-2">
                <vs-button @click="saveKey()" :disabled="disabled_btn" color="primary" type="border">Enregistrer</vs-button>
                <vs-button @click="back()" v-if="status === false" :disabled="disabled_btn" color="danger" type="border">Annuler</vs-button>
              </div>
            </vs-row>
          </vs-card>
        </div>
        <div class="vx-col w-full lg:w-2/3">
          <vs-card>
            <div slot="header">Liste des clés</div>
            <vs-table ref="table" search pagination max-items="10" :data="item.keys ? item.keys : []">
              <template slot="thead">
                <vs-th sort-key="title">Clé</vs-th>
                <vs-th sort-key="categorie">Pondération</vs-th>
                <vs-th sort-key="status">Objecif</vs-th>
                <vs-th>Action</vs-th>
              </template>
              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.key }}</vs-td>
                    <vs-td>{{ tr.ponderation }}</vs-td>
                    <vs-td>{{ tr.objectif }}</vs-td>
                    <vs-td>
                      <feather-icon v-if="tr.key !== 'TTC'" @click="removeKey(tr, item)"
                        icon="DeleteIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                      />
                      <feather-icon @click="modifierEl(tr, item)" v-if="tr.key !== 'TTC'"
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                      />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </vs-card>
        </div>
      </div>
    </v-tab>
</vue-tabs>    
</div>
</template>
<script>
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
const DEFAULT_FIELDS = {
    key: '',
    description: '',
    ponderation: 10,
    objectif: '',
    type_id: ''
  }
export default {
  components: {VueTabs,VTab},
  data : () => ({
    typeAgencies: [],
    status: true,
    error:[],
    keys: {},
    disabled_btn: false,
    elToModify: {},
    tabInfoData: {},
    parents: {}
  }),

  methods:{
    handleTabChange(tabIndex, tab){
      let tab_id = tab.tabId
      let tabData = this.typeAgencies.find((c) => c.slug === tab_id)
      this.tabInfoData = tabData
      if(this.parents.id){
        this.back()
      }
      this.loadKey(tabData.id)
    },

    loadKey(type){
      this.$vs.loading()
      this.error = []
      this.$http.get('/load/key/with/type?type='+type+'&period='+this.$route.params.slug).then((response) =>{
        let content = response.data
        let index = this.typeAgencies.indexOf(this.tabInfoData)
        this.typeAgencies[index].keys = content
        this.$vs.loading.close()
      }).catch((error) => {
        this.$vs.loading.close()
      })
    },
    saveKey(){
      if (this.status === true){
        this.disabled_btn = true
        if (this.tabInfoData.id){
          let tosend = { ...this.tabInfoData }
          tosend.form.type_id = tosend.slug
          this.$http.post('/periods/keys/'+this.$route.params.slug, tosend.form).then((response) =>{
            this.error = []
            let index = this.typeAgencies.indexOf(this.tabInfoData)
            this.typeAgencies[index].keys.unshift(response.data)
            this.typeAgencies[index].form = { ...DEFAULT_FIELDS }
            window.getApp.success("Clé ajouté", {})
            this.disabled_btn = false
          }).catch((error) =>{
            this.disabled_btn = false
            this.error = error.response.data.errors
          })
        }else{
          let firstData = this.typeAgencies[0]
          firstData.form.type_id = firstData.slug
          this.$http.post('/periods/keys/'+this.$route.params.slug, firstData.form).then((response) =>{
            this.error = []
            this.typeAgencies[0].keys.unshift(response.data)
            this.typeAgencies[0].form = { ...DEFAULT_FIELDS }
            window.getApp.success("Clé ajouté", {})
            this.disabled_btn = false
          }).catch((error) =>{
            this.disabled_btn = false
            this.error = error.response.data.errors
          })
        }
      }else {
        this.disabled_btn = true
        let i = this.typeAgencies.indexOf(this.parents)
        console.log(this.typeAgencies[i].form)
        this.$http.put('/periods/keys/'+this.elToModify.slug, this.typeAgencies[i].form).then((response) =>{
          this.error = []
          let index = this.typeAgencies[i].keys.indexOf(this.elToModify)
          this.typeAgencies[i].keys.splice(index, 1, response.data);
          window.getApp.success("Clé modifié", {})
          this.back()
          this.disabled_btn = false
        }).catch((error) =>{
          this.disabled_btn = false
          this.error = error.response.data.errors
        })
      }
    },

    back(){
      this.elToModify = {}
      let index = this.typeAgencies.indexOf(this.parents)
      this.typeAgencies[index].form = { ...DEFAULT_FIELDS }
      this.parents = {}
      this.status = true
    },

    modifierEl(el, parent){
      console.log(el)
      this.elToModify = el
      this.parents = parent
      let index = this.typeAgencies.indexOf(parent)
      this.typeAgencies[index].form = {
        key: el.key,
        description: el.description,
        ponderation: el.ponderation,
        objectif: el.objectif,
        type_id: el.type_agence_id
      }
      this.status = false
    },
    removeKey(el, item){
      if (confirm('Voulez vous supprimer cette clé ?')){
        this.$vs.loading()
        this.$http.delete('/periods/keys/'+el.slug).then(() => {
          let parent = this.typeAgencies.indexOf(item)
          let index = this.typeAgencies[parent].keys.indexOf(el)
          this.typeAgencies[parent].keys.splice(index, 1)
          window.getApp.success("Clé supprimé", {})
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          console.log(error)
        })
      }
    },
    loadHeaderKey(){
      this.$vs.loading()
      this.$http.get('/period/key/header?slug='+this.$route.params.slug).then((response) =>{
        this.typeAgencies = response.data
        this.$vs.loading.close()
      }).catch((error) =>{
        console.log(error)
        this.$vs.loading.close()
      })
    }
  },
  mounted(){
    this.loadHeaderKey()
  }
}
</script>